<template>
  <div class="DownLoadFileArea">
    <div class="noteArea" v-if="showNoteFlg">
        <b-notification
            type="is-warning"
            :closable="false"
            has-icon
            role="alert">
             ダウンロード完了後、90日経過すると、再DLできなくなります。
        </b-notification>
    </div>
    <div class="listArea">
      <ul>
        <li v-for="(file,index) in fileList" :key="index">
          <a @click="downloadFile(file.fileAddress, file.fileId)">
            <b-icon icon="paperclip" />{{file.fileName}}
          </a>
          <span v-if="file.downloadFlag" class="download"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownLoadFileList",
  props: {
    fileList:{},
    showNoteFlg:{}
  },
  methods: {
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
              a.target="_blank"
            }
            _this.$emit('download', fileId, result.obj.requestDLFlag);
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
      
    },
  },
  data() {
    return {
    };
  },
  filters: {},
  components: {}
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.DownLoadFileArea {
  margin:20px;
}
.noteArea {
  margin-bottom: 20px;
}
.listArea {
  text-align: left;
}
.listArea li{
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/DownLoadFileList.vue